import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const DropzoneUploadWrapper = ({ children, allowUploads = true }) => (
  <div
    className={classNames('rounded-sm', {
      'border border-dashed border-gray-light6 cursor-pointer': allowUploads,
    })}
  >
    {children}
  </div>
);

DropzoneUploadWrapper.propTypes = {
  children: PropTypes.node,
  allowUploads: PropTypes.bool,
};

export default DropzoneUploadWrapper;
